(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wp-evidence-carousel"] && !Shopify.designMode) return;
  try {
    
  class WPEvidenceCarousel {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-wp-evidence-track]');
      this.dotsWrap = root.querySelector('[data-wp-evidence-dots]');

      if (!this.track) return;

      this.realSlides = Array.from(this.track.children);
      this.count = this.realSlides.length;

      if (this.count < 2) return;

      this.cloneCount = Math.min(3, this.count);
      this.autoplayDelay = parseInt(root.dataset.autoplay, 10) || 4000;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.timer = null;
      this.resumeTimer = null;
      this.correcting = false;
      this.virtualIndex = this.cloneCount;

      this.cloneSlides();
      this.dots = this.dotsWrap ? Array.from(this.dotsWrap.querySelectorAll('[data-wp-evidence-dot]')) : [];
      this.bindEvents();

      requestAnimationFrame(() => {
        this.goTo(this.cloneCount, false);
        if (!this.reduceMotion) this.startAutoplay();
      });
    }

    cloneSlides() {
      const head = this.realSlides.slice(0, this.cloneCount).map((node) => {
        const clone = node.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        return clone;
      });
      const tail = this.realSlides.slice(-this.cloneCount).map((node) => {
        const clone = node.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        return clone;
      });

      tail.forEach((clone) => this.track.insertBefore(clone, this.track.firstChild));
      head.forEach((clone) => this.track.appendChild(clone));

      this.allSlides = Array.from(this.track.children);
    }

    slideStep() {
      const first = this.allSlides[0];
      const rect = first.getBoundingClientRect();
      const styles = getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0');
      return rect.width + gap;
    }

    realIndexOf(virtualIndex) {
      return (((virtualIndex - this.cloneCount) % this.count) + this.count) % this.count;
    }

    goTo(virtualIndex, smooth) {
      const step = this.slideStep();
      this.virtualIndex = virtualIndex;
      this.track.scrollTo({ left: virtualIndex * step, behavior: smooth ? 'smooth' : 'auto' });
      this.updateDots();
    }

    goToReal(realIndex, smooth) {
      const currentReal = this.realIndexOf(this.virtualIndex);
      const delta = ((realIndex - currentReal) % this.count + this.count) % this.count;
      this.goTo(this.virtualIndex + delta, smooth);
    }

    next() {
      this.goTo(this.virtualIndex + 1, true);
    }

    updateDots() {
      if (!this.dots.length) return;
      const active = this.realIndexOf(this.virtualIndex);
      this.dots.forEach((dot, i) => {
        dot.setAttribute('aria-current', i === active ? 'true' : 'false');
      });
    }

    correctLoop() {
      if (this.correcting) return;
      const step = this.slideStep();
      const rawIndex = Math.round(this.track.scrollLeft / step);
      let corrected = null;

      if (rawIndex < this.cloneCount) {
        corrected = rawIndex + this.count;
      } else if (rawIndex >= this.cloneCount + this.count) {
        corrected = rawIndex - this.count;
      }

      if (corrected !== null) {
        this.correcting = true;
        this.track.scrollTo({ left: corrected * step, behavior: 'auto' });
        this.virtualIndex = corrected;
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.correcting = false;
          });
        });
      } else {
        this.virtualIndex = rawIndex;
      }

      this.updateDots();
    }

    startAutoplay() {
      this.stopAutoplay();
      this.timer = setInterval(() => this.next(), this.autoplayDelay);
    }

    stopAutoplay() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    }

    pauseThenResume() {
      this.stopAutoplay();
      clearTimeout(this.resumeTimer);
      this.resumeTimer = setTimeout(() => {
        if (!this.reduceMotion) this.startAutoplay();
      }, 3500);
    }

    bindEvents() {
      let scrollTimeout;
      this.track.addEventListener(
        'scroll',
        () => {
          if (this.correcting) return;
          clearTimeout(scrollTimeout);
          scrollTimeout = setTimeout(() => this.correctLoop(), 150);
        },
        { passive: true }
      );

      this.track.addEventListener('pointerdown', () => this.pauseThenResume());
      this.root.addEventListener('mouseenter', () => this.stopAutoplay());
      this.root.addEventListener('mouseleave', () => {
        if (!this.reduceMotion) this.startAutoplay();
      });
      this.root.addEventListener('focusin', () => this.stopAutoplay());
      this.root.addEventListener('focusout', () => this.pauseThenResume());

      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          this.goToReal(i, true);
          this.pauseThenResume();
        });
      });

      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => this.goTo(this.virtualIndex, false), 200);
      });
    }
  }

  function initWPEvidenceCarousels(scope) {
    (scope || document).querySelectorAll('[data-wp-evidence-carousel]').forEach((el) => {
      if (el.dataset.wpEvidenceInit) return;
      el.dataset.wpEvidenceInit = 'true';
      new WPEvidenceCarousel(el);
    });
  }

  initWPEvidenceCarousels(document);
  document.addEventListener('shopify:section:load', (event) => initWPEvidenceCarousels(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wp-field-proof"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var isMobile = window.matchMedia('(max-width: 749px)');
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function initTrack(track) {
      if (track.dataset.wpProofInit === '1') return;
      track.dataset.wpProofInit = '1';

      var paused = false;
      var resumeTimeout = null;

      function pause() {
        paused = true;
        if (resumeTimeout) window.clearTimeout(resumeTimeout);
      }

      function scheduleResume() {
        if (resumeTimeout) window.clearTimeout(resumeTimeout);
        resumeTimeout = window.setTimeout(function () {
          paused = false;
        }, 4000);
      }

      track.addEventListener('pointerdown', pause, { passive: true });
      track.addEventListener('pointerup', scheduleResume, { passive: true });
      track.addEventListener('touchstart', pause, { passive: true });
      track.addEventListener('touchend', scheduleResume, { passive: true });

      window.setInterval(function () {
        if (!isMobile.matches || prefersReducedMotion.matches || paused) return;
        var items = track.querySelectorAll('.wp-proof2__item');
        if (!items.length) return;
        var step = items[0].getBoundingClientRect().width + 12;
        var maxScroll = track.scrollWidth - track.clientWidth;
        if (track.scrollLeft >= maxScroll - 4) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: step, behavior: 'smooth' });
        }
      }, 2800);
    }

    document.querySelectorAll('[data-wp-proof-track]').forEach(initTrack);
  })();

  } catch(e) { console.error(e); }
})();
})();
